<template>
  <div class="table">
    <div class="container">
      <el-row>
        <el-button size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
      </el-row>
      <div class="handle-box">
        <el-form :model="headData" :label-position="labelPosition" ref="headDataForm" label-width="140px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="headData.applyNo" :disabled="true" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.applyType')" prop="applyType">
                <!--类型-->
                <el-select v-model="headData.applyType" :disabled="true" class="handle-input" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.subject')">
                <!--主题-->
                <el-input class="handle-input" v-model="headData.subject" :disabled="true" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                <!--报价类型-->
                <el-select v-model="headData.quotationType" class="handle-input" :disabled="true" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="历史报价" name="line">
          <!--历史报价-->
          <div v-for="(round,i) in roundList" :key="i">
            <el-row :gutter="16">
              <!--轮次-->
              <el-col :span="2">{{$t('apply.round')}}：</el-col>
              <el-col :span="1">{{round.roundNumber}}</el-col>
              <!--报价提交日期-->
              <el-col :span="3">{{$t('apply.quoteSubmitDate')}}：</el-col>
              <el-col :span="3">
                <el-link> {{round.submitDate}} </el-link>
              </el-col>
              <!--轮次说明-->
              <el-col :span="2">{{$t('apply.roundRemark')}}：</el-col>
              <el-col :span="4">{{round.remark}}</el-col>
              <!--轮次附件-->
              <el-col :span="2">
                <el-link type="primary" @click="showAttachmentDialogM($t('apply.roundAttachment'),round.ttQuotationApplyRoundId,'QUOTATION_APPLY_ROUND')">{{$t('apply.roundAttachment')}}</el-link>
              </el-col>
              <!--报价附件-->
              <el-col :span="3">
                <el-link type="primary" @click="showAttachmentDialogM($t('apply.quoteAttachment'),round.ttQuotationId,'QUOTATION',round.tmSupplierId)">{{$t('apply.quoteAttachment')}}</el-link>
              </el-col>
            </el-row>
            <ux-grid ref="quotationLineTableDataRef" :data="round.quotationLineList" keep-source max-height="560" show-overflow="tooltip" highlight-current-row>
              <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.supplier')" field="supplierName" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.shippingCity')" field="pickupPoint" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.arrivalAarehouse')" field="dcName" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.temperature')" field="temperatureI18n" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.unit')" field="unit" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.transportaionMethod')" field="transportaionMethod" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.effectiveBeginDate')" field="effectiveBeginDate" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.priceNotTax')" field="price" min-width="130px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.currentLinePrice')" field="linePrice" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.currency')" field="currencyCode" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable title="Leadtime" field="leadTime" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('common.remarks')" field="remarks" min-width="120px"></ux-table-column>
              <ux-table-column align="center" resizable :title="$t('apply.sourcingApprovalStatus')" field="sourcingLineStatus" min-width="140px"></ux-table-column>
            </ux-grid>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="title" :visible.sync="showAttachmentDialog" append-to-body width="60%">
      <el-table :data="attachmentList" border highlight-current-row class="table">
        <el-table-column sortable prop="documentName" label="文件" min-width="130px">
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <el-table-column sortable prop="userName" label="创建人" min-width="130px"></el-table-column>
        <el-table-column sortable prop="createDate" label="创建时间" min-width="130px">
          <template slot-scope="scope">
            {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { quotationService } from "../../../api/quotation-apply-sup/quotation-service";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
export default {
  name: 'quotation-history',
  data() {
    return {
      ttQuotationApplyId: null,
      labelPosition: 'right',
      headData: {},
      quotationLineTableData: [],
      applyTypeList: [],
      quotationTypeList: [],
      fileList: [],
      activeName: 'line',
      roundList: [],

      showAttachmentDialog: false,
      attachmentList: [],
      title: '',
      tmSupplierId: null,
    }
  },
  created() {
    this.getInputChoiceValues();
    this.quotationHistoryPageInitM(this.$route.params.applyId);
    this.ttQuotationApplyId = this.$route.params.applyId;
  },
  methods: {
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件列表数据获取
    showAttachmentDialogM: function (title, recId, reckindId, seq) {
      this.showAttachmentDialog = true;
      this.title = title;
      let attachment = {};
      if (!!seq) {
        attachment.seq = seq + '';
      }
      attachment.tsRecId = recId;
      attachment.tsReckindId = reckindId;
      fileService.getFileList(attachment).then((fileRes) => {
        this.attachmentList = fileRes;
      })
    },
    quotationHistoryPageInitM(applyId) {
      let _this = this;
      quotationService.quotationHistoryInit(applyId).then((res) => {
        _this.headData = res.quotationApply;
        _this.roundList = res.roundHistory;
        _this.tmSupplierId = res.tmSupplierId;
      });
    },

    getInputChoiceValues: function () {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
      });
      inputChoiceService.getCurrencyList().then((res) => {
        this.currencyList = res;
      });
    },
    historyBack: function () {
      this.$router.replace({
        path: '/quotation-sp'
      });
    },
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 10px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
